<script setup lang="ts">
import { ref, defineProps, withDefaults } from 'vue';
import VueBarcode from '@chenfengyuan/vue-barcode';
import Qrcode from "@/components/ui/Qrcode.vue";
import {
  SearchableModel,
  type SearchableModelProps
} from "@/components/searchable-model";

const props = withDefaults(
  defineProps<SearchableModelProps>(),
  {
    modelName: "Equipment",
    loadOnStart: true,
  }
);

const codeType = ref<'qrcode' | 'barcode'>('qrcode');

</script>
<template>
  <SearchableModel
    v-bind="props"
  >
    <template #header-title>
      <h4>{{ $t("Items list") }}</h4>
    </template>
    <template #header-actions>
      <select v-model="codeType" class="form-control">
        <option value="qrcode">QR Code</option>
        <option value="barcode">Barcode</option>
      </select>
    </template>
    <template #default="{ models }">
        <table class="table">
            <tr v-for="equipment in models" v-bind:key="equipment.id">
                <td>
                    <img :src="equipment.product.image" alt="" width="100">
                </td>
                <td>
                    <h3>{{equipment.product.name}}</h3>
                    <h4>
                        <small v-if="equipment.size">{{ $t('Size:') }} {{equipment.size}}</small>
                        <small v-if="equipment.size && equipment.color">-</small>
                        <small v-if="equipment.color">{{ $t('Color:') }} {{equipment.color}}</small>
                    </h4>
                    <p v-if="equipment.serial_number" class="mb-0"><small>{{ $t('Serial number:') }} {{equipment.serial_number}}</small></p>
                    <p v-if="equipment.reference" class="mb-0"><small>{{ $t('Reference / SKU:') }} {{equipment.reference}}</small></p>
                </td>
                <td class="text-right">
                    <div v-if="equipment.barcode_number" class="tw:text-center">
                      <div v-if="codeType === 'barcode'" class="d-flex flex-column align-items-center">
                        <VueBarcode :value="equipment.barcode_number" width="2" height="50">
                            {{equipment.barcode_number}}
                        </VueBarcode>
                      </div>
                      <div v-else-if="codeType === 'qrcode'"  class="d-flex flex-column align-items-center">
                        <Qrcode :value="equipment.barcode_number" :options="{width: 140}" class="align-self-center">
                        </Qrcode>
                      </div>
                      <div v-else>
                        {{ equipment.barcode_number }}
                      </div>
                    </div>
                </td>
            </tr>
        </table>
    </template>
  </SearchableModel>
</template>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>